'use client'
import * as React from 'react'
import GradientText from 'components/gradient-text/GradientText'
import {heroSectionData} from 'content/blog'
import classes from './styles.module.css'
import clsx from 'clsx'
import Navigation from 'v1/common-components/navigation/Navigation'
import Button from 'v1/common-components/button/Button'
import Image from 'next/image'
import ArrowRightIcon from 'v1/assets/icons/arrow-right.svg'
import {DemoData} from 'v1/types/home-page'
import BookDemoForm from 'v1/page-components/marketing/common/demo-form/BookDemoForm'
import Modal from 'v1/common-components/modal/Modal'

const defaultDemoData = {
  isFreeTrialPage: false,
  isNameRequired: true,
  heading: 'Get ZenAdmin for Free',
  buttonText: 'Submit',
  isTermAndCondition: true,
  thankYouTitle: 'Your Account Has Been Created',
  thankYouParagraph:
    'Please check your email for login details to access your ZenAdmin account. Meanwhile, you can schedule a convenient time for a personalized demo.',
}

export default function BlogHero() {
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false)
  const [demoData, setDemoData] = React.useState<DemoData>({...defaultDemoData})
  const toggleDemoFormModal = (data: DemoData | null = null) => {
    setDemoData(
      data || {
        ...defaultDemoData,
      },
    )
    setModalOpen(prev => !prev)
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.subContainer}>
          <div className={classes.dashedCircle}></div>
          <div className={classes.fullCircle}></div>
          <Navigation />

          <div className={classes.content}>
            <GradientText
              text={heroSectionData.topTitle}
              customStyle={{
                color: 'var(--w-50)',
                textAlign: 'center',
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: 'Instrument Sans',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '20px',
                letterSpacing: '2px',
              }}
              type="secondary"
            />
            <h2 className={clsx('header1', classes.header)}>{heroSectionData.title}</h2>
            <p className={classes.desc}>{heroSectionData.desc}</p>
            <div className={classes.buttons}>
              <Button
                text="Book a demo"
                onClick={() => toggleDemoFormModal({})}
                style={{gap: '12px', borderRadius: '16px', padding: '12px 24px'}}
                iconRight={
                  <span className={classes.btnIconBox}>
                    <Image
                      loading="lazy"
                      src={ArrowRightIcon}
                      alt="login-icon"
                      width={24}
                      height={24}
                    />
                  </span>
                }
                isAnimate={true}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        <BookDemoForm data={demoData} />
      </Modal>
    </>
  )
}
